"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.giveAwardToMemberById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Gives an existing award to an existing member.
 *
 * Award is identified by its stringified `ObjectID`.
 * Member is identified by their Discord ID.
 *
 * ## Usage
 *
 * ```ts
 * const awardId: string = "567678d96778a6876cc78";
 * const memberId: string = "2938274356793";
 *
 * const {
 * 	acknowledged,
 *  insertedId,
 * } = await sdk.giveAwardToMemberById({ awardId, memberId });
 * ```
 *
 * @param params.awardId  - ID of the award to give to selected member.
 * @param params.memberId - ID of member which is supposed to get an award.
 */
const giveAwardToMemberById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { awardId, memberId } = params;
    const url = `${BASE_URL}/members/member/${memberId}/awards/award/${awardId}`;
    const memberAwardResponse = yield axios_1.default.post(url, {}, { validateStatus: () => true });
    const { status, data } = memberAwardResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.giveAwardToMemberById = giveAwardToMemberById;
